module["exports"] = [
  "#{prefix} #{first_name} #{last_name} #{last_name}",
  "#{first_name} #{last_name} #{last_name}",
  "#{first_name} #{last_name} #{last_name}",
  "#{first_name} #{last_name} #{last_name}",
  "#{first_name} #{last_name} #{last_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es/name/name.js
// module id = 888
// module chunks = 0